import { Fragment, useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Play } from '@doist/icons/brand';
import { Button, Hidden, OverlayButton } from '@doist/marketist';
import { useDialogStore } from '@ariakit/react';
import { ArticlePageHeader } from 'components/article-page-header/article-page-header';
import { getYoutubeId } from 'components/blog-posts/youtube';
import { Modal } from 'components/modal/modal';
import { YouTubeVideo } from 'components/YouTubeVideo/YouTubeVideo';
import { useTranslation } from 'next-i18next';
import { getTemplateImportURL } from 'services/getTemplateImportURL';
import { ModalPreview } from '../modal-preview';
import css from './page-header.module.css';
import type { Template } from 'services/templates/types';
import { syntheticPageView } from '@/services/analytics';
export type PageHeaderProps = {
  template: Template;
  previousTemplateId?: string;
  nextTemplateId?: string;
};
export function PageHeader({
  template,
  previousTemplateId,
  nextTemplateId
}: PageHeaderProps) {
  const {
    t
  } = useTranslation('templates');
  const previewDialog = useDialogStore();
  const videoDialog = useDialogStore();
  const videoDialogState = videoDialog.useState();
  const [hasUserInitiatedPlayback, setHasUserInitiatedPlayback] = useState(false);
  const videoId = template.video_url ? getYoutubeId(template.video_url) : undefined;
  useEffect(() => {
    if (!videoDialogState.open) {
      setTimeout(() => setHasUserInitiatedPlayback(false), 150);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoDialogState.open]);
  return <>
            <ArticlePageHeader title={template.name} backButton={{
      text: t('allTemplates'),
      href: '/templates'
    }} thumbnail={{
      src: `${template.video_thumbnail_image ? `${template.video_thumbnail_image}?w=864` : `${template.thumbnail_image}?w=270`}`,
      viewType: template.video_thumbnail_image ? 'image' : 'icon',
      backgroundColor: template.background_color || '#FAF8F0',
      accessoryView: videoId ? <OverlayButton className={css.thumbnailBtn} size="small" variant="squared" startIcon={Play} title={t('watchVideo')} onClick={() => {
        if (window.innerWidth < 480) {
          window.open(template.video_url);
        } else {
          videoDialog.show();
          setHasUserInitiatedPlayback(true);
        }
      }} /> : undefined
    }} buttons={[<Fragment key="actions-btn">
                        <Hidden above="lg">
                            <Button target="_blank" size="small" onClick={() => {
          const pageURL = new URL(window.location.toString());
          pageURL.pathname = `${pageURL.pathname}/preview`;
          syntheticPageView(pageURL.toString(), template.name, window.location.toString());
          previewDialog.show();
        }}>
                                {t(template.template_type === 'setup' ? 'previewSetup' : 'previewTemplate')}
                            </Button>
                        </Hidden>
                        <Hidden below="lg">
                            <Button target="_blank" size="small" href={getTemplateImportURL(template.id)}>
                                {t(template.template_type === 'setup' ? 'useSetupButton' : 'useTemplateButton')}
                            </Button>
                        </Hidden>
                    </Fragment>]} accessoryButtons={[<Button onClick={() => {
      window.location.href = `/templates/${previousTemplateId}`;
    }} key="prev-btn" variant="secondary" startIcon={ChevronLeft} disabled={!previousTemplateId} aria-label={t('browsePreviousTemplate')} />, <Button onClick={() => {
      window.location.href = `/templates/${nextTemplateId}`;
    }} key="next-btn" variant="secondary" startIcon={ChevronRight} disabled={!nextTemplateId} aria-label={t('browseNextTemplate')} />]} data-sentry-element="ArticlePageHeader" data-sentry-source-file="page-header.tsx" />

            <ModalPreview store={previewDialog} template={template} data-sentry-element="ModalPreview" data-sentry-source-file="page-header.tsx" />
            {videoId && hasUserInitiatedPlayback ? <Modal store={videoDialog}>
                    <YouTubeVideo className={css.youtubeVideo} videoID={videoId} playerVars={{
        loop: 0,
        autoplay: 1,
        mute: 0,
        playsinline: 0
      }} />
                </Modal> : null}
        </>;
}